module.exports = __webpack_public_path__ + "static/Logo-6ef0435c5fd9dfc78c9e919440c5b0c5.png";